import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core";


const MaterialCircle = withStyles({
  root: {
    color: '#277661'
  }
})(CircularProgress);

export default MaterialCircle;
